import { render } from "./SaleList.vue?vue&type=template&id=a2aaa4f4&scoped=true"
import script from "./SaleList.vue?vue&type=script&lang=js"
export * from "./SaleList.vue?vue&type=script&lang=js"

import "./SaleList.vue?vue&type=style&index=0&id=a2aaa4f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2aaa4f4"]])

export default __exports__